import {TopMenu} from "../Components/TopMenu";
import {Layout} from "antd";
import {Routes} from "../Utils/Routes";

export const Index = () => {
  return(
    <>
      <TopMenu />
      <Layout.Content>
        <Routes />
      </Layout.Content>
      <Layout.Footer>
        <p style={{ textAlign: 'center' }}>
          © 2022 All rights reserved. The use of COVID-19Base is free for academic and non-profit users.
        </p>
      </Layout.Footer>
    </>
  )
}